<template>
  <div class="rating">
    <h4>Рейтинг</h4>

    <ul class="rating__items">
      <li
        class="rating__item"
        v-for="(item, key) in this.teamRating"
        :key="item.id"
      >
        <div class="rating__left">
          <span class="rating__num" uk-tooltip="Номер">
            {{ key + 1 }}
          </span>
          <div class="rating__name">
            <span></span>
            <span>{{ item.title }}</span>
            <br />
          </div>
        </div>
        <div class="rating__scores" uk-tooltip="Набрано баллов">
          {{ item.score }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import vSelect from 'vue-select'
export default {
  inject: ["http"],
  components: { vSelect },
  data() {
    return {
      teamRating: [],
      levelToFilter: 1,
    };
  },
  computed: {
    filteredRating() {
      return this.teamRating.filter(item => item.level === this.levelToFilter)
    },
  },
  methods: {
    getTeamRating() {
      this.http
        .post("onGetMatriusTopTeams")
        .then((res) => {
          this.teamRating = res.data;
          console.log(this.teamRating);
        })
        .catch((e) => swal("Что-то пошло не так", "" + e, "error"));
    },
  },
  created() {
    this.getTeamRating();
  },
};
</script>

<style lang="scss" scoped>
.rating {
  width: 100%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.rating__name {
  & img {
    width: 40px;
    border-radius: 8px;
    margin-right: 10px;
  }
}

.rating__left {
  display: flex;
  align-items: center;
}

.rating__items {
  width: 100%;
}

.setup__item div {
  display: flex;
  justify-content: center;
}
.setup__item label {
  margin-bottom: 5px;
}
</style>